import React, { FC, memo } from "react";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import GenButton, { GenButtonProps } from "../GenButton/GenButton";
import { PRIMARY_COLOR } from "../../themes/gen-theme";

export interface GenFooterProps {
  primaryButtonProps?: GenButtonProps;
  secondaryButtonProps?: GenButtonProps;
}

const GenFooter: FC<GenFooterProps> = (props) => {
  const { primaryButtonProps, secondaryButtonProps } = props;
  const { t } = useTranslation();
  return (
    <Container
      maxWidth={false}
      sx={{
        position: "fixed",
        bottom: 0,
        display: "flex",
        padding: "10px 15px",
        backgroundColor: PRIMARY_COLOR,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        marginTop={1}
        marginBottom={1}
        flexGrow={1}
      >
        {secondaryButtonProps ? (
          <GenButton
            {...secondaryButtonProps}
            variant="outlined"
            color="secondary"
          >
            {secondaryButtonProps?.children
              ? secondaryButtonProps.children
              : t("back")}
          </GenButton>
        ) : (
          <Box></Box>
        )}
        <GenButton {...primaryButtonProps} variant="contained">
          {primaryButtonProps?.children
            ? primaryButtonProps.children
            : t("back")}
        </GenButton>
      </Box>
    </Container>
  );
};

export default memo(GenFooter);
